<template>
    <v-container class="max-container"  @keydown.enter.prevent="enter()">
        <v-row>
            <v-col xs="12" sm="12" md="12" lg="12" class="flex-col-center title-center">
                <h1 class="h1--small text-center"> Que bom te ver de novo por aqui!! </h1>
                <h4 class="h4--small text-center"> Insira seus dados de login e resgate seus prêmios. </h4>
            </v-col>
        </v-row>

        <div class="margin-top-divider-30" />        

        <!--
        A001 Otávio Gomes 25/09/2023 - retirar login com facebook pois está impedindo publicação na apple
                                       depois que publicar, identificar como fazer login api da apple e 
                                       recolocar login com facebook
        <v-row class="flex-col-center">
            <v-btn color="var(--cor--facebook)" class="custom-btn" @click="facebookLogin()">
                <v-icon color="var(--cor--branco)"> mdi-facebook </v-icon>
                <span class="text-white text-none btn__text-icon">Entrar com Facebook</span>
            </v-btn>
        </v-row>
        -->
        
        <div class="margin-top-divider-30" />

        <v-row class="flex-col-center">
            <v-col class="container-login__col_or">
                <div class="lines" />

                <!-- <div class="or" >OU</div> -->

                <div class="lines" />
            </v-col>
        </v-row>

        <div class="margin-top-divider-30" />

        <v-row>
            <v-form class="w-100" v-model="validation">
                <v-row class="login-forms__row">
                    <v-col xs="12" sm="12" md="6" lg="6" class="col-form__login no-pd-b">
                        <div>
                            <v-icon> mdi-email-outline </v-icon> E-mail
                        </div>
                        <v-text-field
                            color="var(--cor--preta)"
                            placeholder="seuemail@email.com"
                            v-model="loginInfo.username"
                            @change="$v.loginInfo.username.$touch()"
                            @blur="$v.loginInfo.username.$touch()"
                            :error-messages="emailErrors"
                            clearable
                        ></v-text-field>
                    </v-col>

                    <v-col xs="12" sm="12" md="6" lg="6" class="col-form__login no-pd-b">
                        <div>
                            <v-icon> mdi-lock-outline </v-icon> Senha
                        </div>
                        <v-text-field
                            color="var(--cor--preta)"
                            placeholder="**********"
                            v-model="loginInfo.password"
                            :type=" ShowPassword? 'text' : 'password'"
                            :append-icon="ShowPassword ? 'mdi-eye' : 'mdi-eye-off'"
                            @click:append="ShowPassword = !ShowPassword"
                            @change="$v.loginInfo.password.$touch()"
                            @blur="$v.loginInfo.password.$touch()"
                            :error-messages="passwordErrors"
                        ></v-text-field>
                    </v-col>
                </v-row>
            </v-form>
        </v-row>

        <div class="margin-top-divider-30" />

        <v-row class="flex-row-center">
            <v-col xs="12" sm="12" md="12" lg="12" class="w-100 flex-col-center">
                <v-btn :color="currentCompany.buttonsColor" class="custom-btn"  @click="enter()" :disabled="!validation" :loading="btnLoadingLogin">
                    <v-icon v-if="!validation" size="16" left> mdi-lock </v-icon>
                    <span class="text-none text-white"> Acessar minha conta </span>
                </v-btn>
            </v-col>
            <v-col xs="12" sm="12" md="12" lg="12" class="w-100 flex-col-center">
                <v-btn color="var(--cor--azul)" text class="custom-btn mg-b-12" @click="redirectToSignup()">
                    <span class="text-none"> Não possui acesso? </span>
                </v-btn>

                <v-btn color="var(--cor--azul)" text class="custom-btn" @click="openRevocerPasswordModal()">
                    <span class="text-none"> Esqueci a minha senha </span>
                </v-btn>
            </v-col>
        </v-row>

        <div v-if="recoverPasswordDialog">
            <RecoverPasswordModal :dialog="recoverPasswordDialog" @closeRecoverPasswordModal="recoverPasswordDialog = $event" />
        </div>
        
    </v-container>
</template>     

<script>
//Store
import { mapGetters, mapActions } from "vuex"

//Plugin
import { required, email } from 'vuelidate/lib/validators'

//Functions
import { passwordRule } from "@/support/functions/validation.function";

//Services
import { authenticate } from "@/domain/auth/auth.service";
import { getImageByCurrentId } from "@/app/shared-components/navbar/service/navbar.service";

//Components
import RecoverPasswordModal from "@/app/modals/recover-password-modal/recover-password-modal";

export default {
    name: 'Login',
    components: { RecoverPasswordModal },
    computed: {
        emailErrors () {
            const errors = []
            if (!this.$v.loginInfo.username.$dirty) return errors
            !this.$v.loginInfo.username.required && errors.push('E-mail é obrigatório.')
            !this.$v.loginInfo.username.email && errors.push('Este e-mail não é válido.')
            return errors
        },
        passwordErrors () {
            const errors = []
            if (!this.$v.loginInfo.password.$dirty) return errors
            !this.$v.loginInfo.password.required && errors.push('Senha é obrigatória.')
            !this.$v.loginInfo.password.passwordRule && errors.push('Senha tem que ter no mínimo 8 caracteres.')
            return errors
        },
        ...mapGetters('authenticateStore', {
                currentCompany: 'get_currentCompany'
            }
        )
    },
    validations: {
        loginInfo: {
            username: { required, email },
            password: { required, passwordRule }
        }
    },
    data: () => ({
        loginInfo: {
            username: "",
            password: "",
            platform: 'cative',
            subdomain: "",
            facebookAccessToken: null
        },
        validation: false,
        btnLoadingLogin: false,
        recoverPasswordDialog: false,
        ShowPassword: false
    }),
    created() {
        this.getSubdomain()
    },
    methods: {
        ...mapActions('authenticateStore', ['TO_LOG', 'FACEBOOK_LOGIN']),
        ...mapActions('userStore', ['SET_USER_IMAGE']),
        getSubdomain() {
            if (window.location.host.endsWith(".lity.com.br")) {
                this.loginInfo.subdomain = window.location.host.split(".")[0]
            } else if ( window.location.host.includes('.canelhas.ddns.net') ) {
                this.loginInfo.subdomain = "canalhasbar"

            }else {
                this.loginInfo.subdomain = window.location.host
            }
        },
        openRevocerPasswordModal() {
            this.recoverPasswordDialog = true
        },
        enter() {
            this.btnLoadingLogin = true;
            if(this.validation) {

                authenticate( this.loginInfo )
                    .then( success => {
                            if( success.data ) {
                                this.TO_LOG(success.data)
                                this.getCurrentUserImageByBackend()
                                this.$router.push( {path: '/inicio'} )
                            }
                        }
                    )
                    .catch( error => {
                            this.btnLoadingLogin = false;
                            if (error != null) {
                                if( error.message.startsWith('Não existe uma conta') ) {
                                    this.$toasted.show(`${error.message}, crie agora e aproveite o nosso clube de benefícios.`, { type: 'info', duration: 4000 } )
                                    this.redirectToSignup()

                                } else this.$toasted.show(error.message == "Access Denied" ? " Usuário e/ou senha inválidos. " : error.message, { type: 'error' } )
                            }
                        }
                    )
            }
        },
        redirectToSignup() {
            this.$router.push( {path: '/acessos'} )
        },
        facebookLogin() {
            this.FACEBOOK_LOGIN()
                .then( success => {
                        this.validation = true
                        this.loginInfo.facebookAccessToken = success.accessToken
                        this.enter()
                    }
                )
                .catch( error => {
                        this.$toasted.show(error , { type: 'error' } )
                    }
                )
        },
        getCurrentUserImageByBackend() {
            getImageByCurrentId()
                .then( success => {
                        success.data.image !== null ? this.SET_USER_IMAGE( success.data.image ) : ''
                    }
                )
                .catch( error => {
                        if (error != null) {
                            this.$toasted.show(error.message, { type: 'error' } )
                        }
                    }
                )
        }
    }
}
</script>

<style scoped>

/*------------------- LOADING -------------------- */
::v-deep .custom-btn.theme--light.v-btn {
    color: var(--cor--branco);
}

.title-center{
    text-align: center;
}
@media (max-width: 600px) {
    .login-forms__row{
        flex-direction: column !important;
    }
}
.login-forms__row{
    display: flex;
    flex: auto !important;
    flex-direction: row;
    justify-content: center;
    align-items: center;
}
.col-form__login {
    max-width: 300px;
}
.container-login__col_or{
    display: flex;
    flex: auto !important;
    color: var(--cor--cinza);
    justify-content: center;
    align-items: center;
    min-width: 300px;
    max-width: 660px;
    width: 100%
}
.lines{
    border: 0.5px solid var(--cor--cinza);
    width:40%;
    height: 1px;
}
.or{
    color: var(--cor--cinza);
    margin-left: 10px !important;
    margin-right: 10px !important;
    font-size: 20px;
    font-weight: 600;
}
.mg-b-12 {
    margin-bottom: 12px;
}
.h1--small {
    font-size: 28px !important;
    font-weight: 600 !important;
}
.h4--small {
    font-weight: 700 !important;
}
</style>
